export const girls = [
    {title:"Bowie", url:"dogs/girls/bowie"},
    {title:"Mira", url:"dogs/girls/mira"},
];